import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { catchError, forkJoin, of, Subscription, tap } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Folder, Group } from 'src/app/classes/fileInfo';
import { FileService } from 'src/app/services/file.service';
import { accordeonMe } from 'src/app/animations';


@Component({
	selector: 'app-file-group-management',
	templateUrl: './file-group-management.component.html',
	styleUrls: [ '../management-interface.css', '../accordeon-ui.scss' ],
	animations: [ accordeonMe ],
})
export class FileGroupManagementComponent implements OnInit, OnDestroy {


	elements: Group[] = [];
	currentFilter = "";
	filteredElements: Group[] = [];
	expandedElementId = "";

	sortingField = 'gruppenname';
	sortingAsc = true;

	folders: Folder[] = [];

	bLoading = true;
	subscriptions = new Subscription();


	constructor(
		private fileService: FileService,
		private matDialog: MatDialog
	) {}


	ngOnInit() {

		forkJoin( [
			this.fileService.getFolders().pipe( 
				tap( folders => {
					this.folders = folders;
				})
			),
			this.fileService.getGroups().pipe( 
				tap( groups => {
					this.elements = groups;
					this.sortElements();
				})
			)
		] ).pipe(
			catchError( e => of(null) )
		).subscribe( r => {
			this.bLoading = false;
		})
		
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}


	sortColumn( field: string ) {

		if( this.sortingField === field ) {
			this.sortingAsc = !this.sortingAsc;
		} else {
			this.sortingField = field;
			this.sortingAsc = true;
		}

		this.sortElements();

	}

	sortElements() {

		this.elements.sort( ( a, b ) => {

			const valueA = (a[this.sortingField] || '').toString();
			const valueB = (b[this.sortingField] || '').toString();
		
			return this.sortingAsc ? valueA.localeCompare( valueB ) : valueB.localeCompare( valueA );

		});

		this.applyFilter();

	}

	clickOnRow( elementId: string ) {

		const bPrevious = !!this.expandedElementId;

		this.expandedElementId = ( this.expandedElementId == elementId ) ? "" : elementId;

		if( bPrevious && this.expandedElementId ) {
			setTimeout( () => {
				const elem = window.document.getElementById( "elementRow_" + elementId );
				if( elem ) {
					elem.scrollIntoView( { behavior: "smooth", block: "start" } );
				}
			}, 500 );
		}

	}

	onFilterChanged( event: Event ) {

		this.currentFilter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase(); 
		this.applyFilter();

	}

	private applyFilter() {

		this.filteredElements = this.elements.filter( u => {

			for( const searchField of [ "gruppenname", "gruppeBeshreibung" ] ) {

				if( !u[ searchField ] ) continue;
				const str = ("" + u[ searchField ]).toLowerCase();
				if( str.includes( this.currentFilter ) ) return true;

			}

			return false;

		});

	}

	showCreationDialog() {

		this.matDialog.open( FileGroupCreatorDialog, {
			maxHeight: '90vh', 
			data: this.folders
		}).afterClosed().subscribe( (group: Group) => {

			if( group && group.gruppenId ) {
				this.elements.push( group );
				this.sortElements();
			}

		});
		
	}

}


@Component( {
	selector: 'file-group-creator-dialog',
	template: `
		<app-file-group-editor
			[allFolders]="folders"
			(done)="creationDone($event)"
		/>
	`
})
export class FileGroupCreatorDialog {

	constructor(
		public dialogRef: MatDialogRef<FileGroupCreatorDialog>,
		@Inject(MAT_DIALOG_DATA) public folders: Folder[],
	) {}

	creationDone( group: Group ) {
		this.dialogRef.close( group );
	}
	
}


